import { render, staticRenderFns } from "./liveBroadcastDetail.vue?vue&type=template&id=664cefdc&scoped=true"
import script from "./liveBroadcastDetail.vue?vue&type=script&lang=js"
export * from "./liveBroadcastDetail.vue?vue&type=script&lang=js"
import style0 from "./liveBroadcastDetail.vue?vue&type=style&index=0&id=664cefdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664cefdc",
  null
  
)

export default component.exports